export interface ReportByCaseManagerProps {
  filterBy: string;
  date: string;
  dateEnd: string;
  tenantId: number;
}
  
export interface ReportsDataObject {
  status: string;
  count: number;
}
  
export interface DataFromApiObject {
  case_manager_name: string | null;
  case_manager_id: number;
}

export interface TotalReportsObject extends DataFromApiObject {
  reports: ReportsDataObject[];
} 

export interface AverageHandlingTimeObject extends DataFromApiObject {
  average_handling_time: number;
} 

export interface BarChartObject {
  data: number[];
  fullLabel: string;
  label: string;
  stack: string;
}

export interface ReportBarChartProps {
  reportsDataList: BarChartObject[],
  reportLabels: string[],
  report: ReportFilters,
  palette: string[],
}
  
export enum ReportFilters {
  TOTAL_REPORTS = 'Total Reports',
  AVG_HANDLING_TIME = 'Average Handling Time',
}